import { createStore, createEffect, createEvent, combine } from 'effector';
import { ApiUtils } from '@shared/utils';
import { RecipientsApi, RequestStrategyEnum, type WithSignal, type GetRecipientRequest, type RecipientResponse } from '@shared/api';

const getRecipientsEffect = createEffect(({ signal, ...request }: WithSignal<GetRecipientRequest> = {}) =>
  RecipientsApi.getRecipients(request, signal),
);
const clearEvent = createEvent();

const $dataStore = createStore<{ total: number; data: RecipientResponse[] }>({ total: 0, data: [] })
  .on(getRecipientsEffect.done, (_, data) => (data.result ? { total: data.result.total, data: data.result.data || [] } : { total: 0, data: [] }))
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(false)
  .on(getRecipientsEffect.pending, (_, data) => data)
  .on(getRecipientsEffect.fail, (_, data) => ApiUtils.abortApiLoadingFailCaseTrigger(data.error))
  .on(getRecipientsEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getRecipientsEffect, () => null)
  // .on(effect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getRecipientsEffect.fail, () => 'Something went wrong while fetching Recipients. Please try again.')
  .on(getRecipientsEffect.done, () => null)
  .reset(clearEvent);

const getRecipientsApi = ApiUtils.wrapperApi(getRecipientsEffect, RequestStrategyEnum.Abort);
clearEvent.watch(() => getRecipientsApi.cancel());

export const $recipientListStore = {
  events: {
    getRecipients: getRecipientsApi.trigger,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
